const API_BASE = '/api';

export interface BackupListItem {
  id: string;
  createdAt: number;
  size: number;
}

export async function fetchBackups(): Promise<BackupListItem[]> {
  try {
    const response = await fetch(`${API_BASE}/backups`, { method: 'GET' });
    if (!response.ok) throw new Error(`Erreur API: ${response.status}`);
    const data = await response.json() as { backups?: BackupListItem[] } | BackupListItem[];
    return Array.isArray(data) ? data : data.backups || [];
  } catch (error) {
    throw error instanceof Error ? error : new Error('Impossible de récupérer les backups.');
  }
}

export async function uploadBackup(
  encryptedHex: string,
  ivHex: string,
  saltHex: string,
  recoveryKeyHint: string,
): Promise<{ id: string }> {
  try {
    const response = await fetch(`${API_BASE}/backup`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ encrypted: encryptedHex, iv: ivHex, salt: saltHex, recoveryKeyHint }),
    });
    if (!response.ok) throw new Error(`Erreur API: ${response.status}`);
    return await response.json() as { id: string };
  } catch (error) {
    throw error instanceof Error ? error : new Error('Impossible d\'uploader le backup.');
  }
}

export async function downloadBackup(id: string): Promise<{ encrypted: string; iv: string; salt: string }> {
  try {
    const response = await fetch(`${API_BASE}/backup/${encodeURIComponent(id)}`, { method: 'GET' });
    if (!response.ok) throw new Error(`Erreur API: ${response.status}`);
    return await response.json() as { encrypted: string; iv: string; salt: string };
  } catch (error) {
    throw error instanceof Error ? error : new Error('Impossible de télécharger le backup.');
  }
}

export async function deleteBackup(id: string): Promise<void> {
  try {
    const response = await fetch(`${API_BASE}/backup/${encodeURIComponent(id)}`, { method: 'DELETE' });
    if (!response.ok) throw new Error(`Erreur API: ${response.status}`);
  } catch (error) {
    throw error instanceof Error ? error : new Error('Impossible de supprimer le backup.');
  }
}
